<app-card-medium title="{{ 'My Profile' | translate }}" [hasAvatar]="true" [avatar]="avatar">
  <div class="content d-flex justify-content-between flex-column" *ngIf="user">
    <div class="card inner-shadow">
      <div class="card-body">
        <div class="description">
          <p>{{ 'Fullname' | translate }}</p>
          <p>{{ user.fullname }}</p>
        </div>
        <div class="description">
          <p>{{ 'Username' | translate }}</p>
          <p>{{ user.username }}</p>
        </div>
        <div class="description">
          <p>{{ 'Email' | translate }}</p>
          <p>{{ user.email }}</p>
        </div>
        <div *ngIf="user.contact_detail" class="description">
          <p>{{ 'Contact Details' | translate }}</p>
          <p>{{ user.contact_detail }}</p>
        </div>
        <div *ngIf="user.job_title" class="description">
          <p>{{ 'Job Titles' | translate }}</p>
          <p>{{ user.job_title }}</p>
        </div>
        <div *ngIf="user.office_address" class="description">
          <p>{{ 'Office Address' | translate }}</p>
          <p>{{ user.office_address }}</p>
        </div>
      </div>
    </div>
    <button type="button" class="btn btn-sm btn-secondary" (click)="onEdit()">{{ 'Edit' | translate }}</button>
  </div>
</app-card-medium>
